__turbopack_context__.v({
  "arrow": "C54m1a_arrow",
  "arrows": "C54m1a_arrows",
  "caption": "C54m1a_caption",
  "container": "C54m1a_container",
  "controls": "C54m1a_controls",
  "counter": "C54m1a_counter",
  "enabled": "C54m1a_enabled",
  "header": "C54m1a_header",
  "image": "C54m1a_image",
  "image-container": "C54m1a_image-container",
});
